import { Show, createUniqueId, splitProps } from "solid-js";
import type { JSX } from "solid-js";

interface Props extends Omit<JSX.InputHTMLAttributes<HTMLInputElement>, "size"> {
    label: string;
    help?: string;
    error?: string;
    size?: "sm" | "md" | "lg";
    fullWidth?: boolean;
}

export function Input(props: Props) {
    const id = createUniqueId();
    const [own, rest] = splitProps(props, [
        "label",
        "help",
        "error",
        "size",
        "fullWidth",
        "class",
        "id",
    ]);
    const inputId = () => own.id ?? `inp-${id}`;
    const cls = () =>
        [
            "ui-input",
            `ui-input-${own.size ?? "md"}`,
            own.fullWidth ? "ui-input-full" : "",
            own.error ? "ui-input-error" : "",
            own.class ?? "",
        ]
            .filter(Boolean)
            .join(" ");

    return (
        <div class={`ui-field${own.fullWidth ? " ui-field-full" : ""}`}>
            <label for={inputId()} class="ui-label">
                {own.label}
            </label>
            <input
                {...rest}
                id={inputId()}
                class={cls()}
                aria-invalid={own.error ? "true" : undefined}
                aria-describedby={
                    own.error ? `${inputId()}-error` : own.help ? `${inputId()}-help` : undefined
                }
            />
            <Show when={own.error}>
                <p id={`${inputId()}-error`} class="ui-error">{own.error}</p>
            </Show>
            <Show when={own.help && !own.error}>
                <p id={`${inputId()}-help`} class="ui-help">{own.help}</p>
            </Show>
        </div>
    );
}
